<template>
	<div>
		<div class="sections">
			<section>
				<h3 v-if="firstLabel">Ist Homeoffice vorgesehen?</h3>
				<RadioGroup
					v-model="type"
					:options="typeOptions"
					stacked
					@input="emitChangeEvent"
				/>
			</section>
			<section v-if="startEligible">
				<h3>Ab wann ist Homeoffice möglich?</h3>
				<b-form-checkbox-group
					v-model="start"
					:options="startOptions"
					@input="emitChangeEvent"
				/>
			</section>
			<template v-if="degreeEligible">
				<section>
					<h3>In welchem Ausmaß?</h3>
					<RadioGroup
						v-model="degree"
						:options="degreeOptions"
						@input="emitChangeEvent"
					/>
				</section>
				<section v-if="degreeDaysEligible">
					<h3>Tage pro Woche</h3>
					<RadioGroup
						v-model="degreeDays"
						:options="degreeDaysOptions"
						stacked
						@input="emitChangeEvent"
					/>
				</section>
			</template>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import * as HomeOffice from "@/helper/job-profile/HomeOffice"
import Select from "@/vue/common/form/Select";
import RadioGroup from "@/vue/common/form/RadioGroup";

export default {

	components: {
		RadioGroup,
		FormGroup,
		Select,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		firstLabel: {
			type: Boolean,
			required: false,
			default: true,
		},
		simple: {
			type: Boolean,
			required: false,
			default: false,
		},
		emitChangeOnMount: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	mounted ()
	{
		if (this.emitChangeOnMount)
		{
			this.emitChangeEvent();
		}
	},

	data ()
	{
		return {
			type: this.value ? this.value.type : null,
			typeOptions: [
				{
					value: HomeOffice.TYPE_YES,
					text: HomeOffice.getTypeLabel(HomeOffice.TYPE_YES)
				},
				{
					value: HomeOffice.TYPE_MAYBE,
					text: HomeOffice.getTypeLabel(HomeOffice.TYPE_MAYBE)
				},
				{
					value: HomeOffice.TYPE_NO,
					text: HomeOffice.getTypeLabel(HomeOffice.TYPE_NO)
				},
			],
			start: this.value && this.value.start ? this.value.start : [],
			startOptions: [
				{
					value: HomeOffice.START_IMMEDIATELY,
					text: HomeOffice.getStartLabel(HomeOffice.START_IMMEDIATELY)
				},
				{
					value: HomeOffice.START_POST_ORIENTATION,
					text: HomeOffice.getStartLabel(HomeOffice.START_POST_ORIENTATION)
				},
			],
			degree: this.value && isDefined(this.value.degree) ? this.value.degree : undefined,
			degreeOptions: Object.freeze([
				{value: HomeOffice.DEGREE_ALL, text: HomeOffice.getDegreeLabel(HomeOffice.DEGREE_ALL)},
				{value: HomeOffice.DEGREE_CUSTOM, text: HomeOffice.getDegreeLabel(HomeOffice.DEGREE_CUSTOM)},
			]),
			degreeDays: this.value && isDefined(this.value.degreeDays) ? this.value.degreeDays : undefined,
			degreeDaysOptions: HomeOffice.getDaysOptions(),
		};
	},

	computed: {
		startEligible ()
		{
			return !this.simple && this.type === HomeOffice.TYPE_YES;
		},
		startValid ()
		{
			return !this.startEligible || arrayIsNotEmpty(this.start);
		},
		degreeEligible ()
		{
			return !this.simple && isDefined(this.type) && this.type !== HomeOffice.TYPE_NO;
		},
		degreeValid ()
		{
			return !this.degreeEligible || isDefined(this.degree);
		},
		degreeDaysEligible ()
		{
			return this.degreeEligible && this.degree === HomeOffice.DEGREE_CUSTOM;
		},
		degreeDaysValid ()
		{
			return !this.degreeDaysEligible || isDefined(this.degreeDays);
		},
		valid ()
		{
			return isDefined(this.type)
				&& this.startValid
				&& this.degreeValid
				&& this.degreeDaysValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				type: this.type,
				start: this.startEligible
					? this.start
					: null,
				degree: this.degreeEligible
					? this.degree
					: null,
				degreeDays: this.degreeDaysEligible
					? this.degreeDays
					: null,
			});
		},
	},
}
</script>
